export default __webpack_public_path__ + "images/get-support.svg";